import n from "nonce";
import React from "react";
import { useLocation } from "react-router-dom";

import { FASTDRAW_URL } from "../../redux/constants";
import { useAppSelector } from "../../redux/hooks";

export interface SynergyAuthProps {
  synergyForm: React.RefObject<HTMLFormElement>;
  playId: string;
}

const SynergyAuth = ({ synergyForm, playId }: SynergyAuthProps) => {
  const auth = useAppSelector((state) => state.auth);
  const location = useLocation();

  const locationString = JSON.stringify({
    ...location,
    playId: playId,
  });

  return (
    <form style={{ display: "none" }} method="post" action={`${FASTDRAW_URL}/auth/synergy`} ref={synergyForm}>
      <input name="nonce" type="hidden" value={n()()} />
      <input name="bearer_token" type="hidden" value={auth.token || ""} />
      <input name="scope" type="hidden" value="api.editor.external offline_access" />
      <input name="redirect_uri" type="hidden" value={`${window.location.origin}`} />
      <input name="state" type="hidden" value={locationString} />
    </form>
  );
};

export default SynergyAuth;
